const _ = require('lodash');
const computed = require('../computed/auth/login');

module.exports = {
    /**
     * Устанавливаем computed поля для страницы логина
     * @param {Object} args
     * @param {Object} state
     */
    setComputedFields (args, state) {
        computed.errorMessage(state);
        computed.errorState(state);
    },

    loginUser (args, state, output, { locator, context }) {
        let loginForm = state.get(['login', 'form']);

        let loginData = {
            grant_type: 'password',
            client_id: 'hermes'
        };

        loginData = Object.assign(loginData, loginForm);

        let API = locator.resolve('api');
        let request = API.authUser(context, { loginData });

        request.then((data) => {
            let code = _.get(data, 'status.code');
            let auth = _.get(data, 'content');

            if (code === 401) {
                output.accessDenied({ code });
                return;
            }

            if (code === 400) {
                output.invalidValidation({ code });
                return;
            }

            if (code === 200) {
                output.success({ auth });
                return;
            }

            output.error({ code });
        })
        .catch((error) => output.error({ error }));
    },

    passLoginInfoToRegistrationForm (args, state) {
        let loginForm = state.get(['login', 'form']);
        if (loginForm) {
            let data = {
                email: loginForm.username,
                password: loginForm.password
            };
            state.set(['registration', 'form'], data);
        }
    }
};



// WEBPACK FOOTER //
// ./actions/auth/login.js